/*
* Different log types that can exist for surveysaurus
*/
export enum LogTypes {
  USERMOVE = 'user move',
}
